import { render, staticRenderFns } from "./CoventryResources.vue?vue&type=template&id=0493e434&"
import script from "./CoventryResources.vue?vue&type=script&lang=js&"
export * from "./CoventryResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports